// extracted by mini-css-extract-plugin
export default {"instruction_paragraph_container":"footer_instruction_paragraph_container__ihHWv","lioncontainer":"footer_lioncontainer__TdJFj","lion":"footer_lion__n81km"};